import React from "react";

import { Trans } from "app/utils";

import linkedin from "images/social/linkedin.svg";

const LinkedinBadge = ({ justIcon, useImageIcon, socialShare }) => {
  if (justIcon) {
    return (
      <p className="SocialBadge linkedin">
        <img height="20px" width="20px" className="social-icon" src={linkedin} alt="Linkedin icon" />
      </p>
    );
  }

  if (useImageIcon) {
    return (
      <p className="SocialBadge linkedin">
        <img height="20px" width="20px" className="social-icon" src={linkedin} alt="Linkedin icon" />
        <Trans> LinkedIn</Trans>
      </p>
    );
  }

  return (
    <p className="SocialBadge linkedin">
      <svg height="22px" viewBox="0 0 384 392" width="22px" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(0.000000, -0.000000)" fill="#FFFFFF">
            <rect fillRule="nonzero" x="10" y="134" width="75" height="255.592105" rx="16" />
            <circle fillRule="nonzero" cx="47.5" cy="47.5" r="47.5" />
            <path d="M212.307693,169.233069 C227.965212,141.87818 257.082746,125 288.615384,125 C337.137538,125 384,153.598967 384,229.86288 L384,372.857716 C384,377.914793 381.992121,382.765181 378.414175,386.341074 C374.836229,389.916968 369.983056,391.923695 364.923076,391.923695 L326.76923,391.923695 C321.70925,391.923695 316.856078,389.916968 313.278132,386.341074 C309.700185,382.765181 307.690789,377.914793 307.692307,372.857716 L307.692307,239.395869 C307.692307,213.071246 286.339734,191.730923 260,191.730923 C233.660266,191.730923 212.307693,213.071246 212.307693,239.395869 L212.307693,372.857716 C212.309211,377.914793 210.299815,382.765181 206.721868,386.341074 C203.143922,389.916968 198.29075,391.923695 193.23077,391.923695 L155.076924,391.923695 C150.016944,391.923695 145.163771,389.916968 141.585825,386.341074 C138.007879,382.765181 136,377.914793 136,372.857716 L136,153.598967 C136,148.54189 138.007879,143.691502 141.585825,140.115609 C145.163771,136.539715 150.016944,134.531471 155.076924,134.532989 L193.23077,134.532989 C198.29075,134.531471 203.143922,136.539715 206.721868,140.115609 C210.299815,143.691502 212.309211,148.54189 212.307693,153.598967 L212.307693,169.233069 Z" />
          </g>
        </g>
      </svg>
      <Trans>LinkedIn</Trans>
    </p>
  );
};

export default LinkedinBadge;
